import { createSelector } from 'reselect';
import type { CasinoSharedRootState } from '../../ducks/types';

const REDUCER_NAME = 'subNavigation';

const submenuSelector = (_: CasinoSharedRootState, submenu?: string) => submenu;

const casinoHydratedSelector = (state: CasinoSharedRootState) => state[REDUCER_NAME].casino.hydrated;
const casinoLoadingSelector = (state: CasinoSharedRootState) => state[REDUCER_NAME].casino.loading;
const casinoGamesSelector = (state: CasinoSharedRootState) => state[REDUCER_NAME] && state[REDUCER_NAME].casino.games;
const casinoCategoriesBySubmenuSelector = (state: CasinoSharedRootState) =>
	state[REDUCER_NAME].casino.categoriesBySubmenu;

const liveCasinoHydratedSelector = (state: CasinoSharedRootState) => state[REDUCER_NAME].liveCasino.hydrated;
const liveCasinoLoadingSelector = (state: CasinoSharedRootState) => state[REDUCER_NAME].liveCasino.loading;
const liveCasinoGamesSelector = (state: CasinoSharedRootState) =>
	state[REDUCER_NAME] && state[REDUCER_NAME].liveCasino.games;
const liveCasinoCategoriesBySubmenuSelector = (state: CasinoSharedRootState) =>
	state[REDUCER_NAME].liveCasino.categoriesBySubmenu;

const casinoSubmenuCategoriesSelector = createSelector(
	[submenuSelector, casinoCategoriesBySubmenuSelector, casinoHydratedSelector],
	(submenu, casinoCategories, isHydrated) => {
		if (!isHydrated || !submenu) {
			return [];
		}

		return casinoCategories[submenu];
	}
);

const liveCasinoSubmenuCategoriesSelector = createSelector(
	[submenuSelector, liveCasinoCategoriesBySubmenuSelector, liveCasinoHydratedSelector],
	(submenu, casinoCategories, isHydrated) => {
		if (!isHydrated || !submenu) {
			return [];
		}

		return casinoCategories[submenu];
	}
);

export {
	casinoHydratedSelector,
	liveCasinoHydratedSelector,
	casinoLoadingSelector,
	liveCasinoLoadingSelector,
	casinoGamesSelector,
	liveCasinoGamesSelector,
	casinoSubmenuCategoriesSelector,
	liveCasinoSubmenuCategoriesSelector
};
